// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/redux.hooks';
import Autocomplete from '../components/form/Autocomplete';
import client from '../clients/client';
import { useToast } from '../components/toast/ToastProvider';

import { useParams } from 'react-router-dom';

/*
 TODO: Update deselectedOptions to a list from DB in MapSize
*/


type Section = {
  title: string;
  options: {
    value: string;
    label: string;
  }[];
};


const MapSize = (props: any) => {
  const sizes = props?.sizes || {}
  const sections: Section[] = Array.isArray(props?.options) ? props.options : []

  return (
    <Autocomplete
      label={props.label}
      labelHidden
      placeholder='Search'
      sections={sections}
      defaultValue={props?.value?.[0] || ''}
      onSelect={(option) => {
        props?.onChange(sizes?.[option.label])
      }}
    />
  );
}


const SizeMapping = () => {
  const params = useParams();
  const [ missingMapping, setMissingMapping ] = useState([]);
  const [ existingMapping, setExistingMapping ] = useState([]);
  const [ addedMapping, setAddedMapping ] = useState({});
  const [ newMapping, setNewMapping ] = useState({});
  const toast = useToast();
  const { id: shop_id } = params;

  const [ sizes, setSizes ] = useState({});
  const [ mappingOptions, setMappingOptions ] = useState({});

  const fetchSizeMapping = () => {
    fetch(`/api/size_mapping/${shop_id}`).then((response) => {
      return response.json()
    }).then((data) => {
      setMissingMapping(data?.missing_mapping || [])
      setExistingMapping(data?.size_mapping || [])

      let sizes = {}
      let size_groups = {}
      data?.sizes?.forEach((size) => {
        sizes[`${size.country} ${size.value}`] = size

        if (!size_groups.hasOwnProperty(size.country)) {
          size_groups[size.country] = {
            title: size.country,
            options: []
          }
        }

        size_groups[size.country].options.push({
          value: `${size.country} ${size.value}`,
          label: `${size.country} ${size.value}`
        })
      })

      setSizes(sizes)
      setMappingOptions(Object.keys(size_groups).map(g => size_groups[g]))
    })
  }

  const handleSave = () => {
    client.post(`/size_mapping/${shop_id}`, newMapping).then((response) => {
      toast.show('Size mapping updated')
      setNewMapping({})
      fetchSizeMapping()
      return response.data
    })
  }

  useEffect(() => {
    fetchSizeMapping()
  }, [])
  
  useEffect(() => {
    setNewMapping({
      ...newMapping,
      ...addedMapping
    })
  }, [addedMapping])

  return (
    <>
      <s-grid gridTemplateColumns='1fr 1fr' gap='base'>
        <s-grid-item>
          <s-section padding='none'>
            <h3 style={{ textAlign: 'center' }}>Missing Mapping</h3>
            {/* Missing mapping */}
            <s-table>
              <s-table-header-row>
                <s-table-header>Size</s-table-header>
                <s-table-header>Map to</s-table-header>
              </s-table-header-row>
              <s-table-body>
              {missingMapping.map((s) => {
                return <s-table-row key={s}>
                  <s-table-cell>{s}</s-table-cell>
                  <s-table-cell>
                    <MapSize
                      label={`Map ${s} to`}
                      sizes={sizes}
                      options={mappingOptions}
                      onChange={(value: String) => {
                        setAddedMapping({
                          [s]: value
                        })
                      }}
                    />
                  </s-table-cell>
                </s-table-row>
              })}
              </s-table-body>
            </s-table>
          </s-section>
        </s-grid-item>
        <s-grid-item>
          <s-section padding='none'>
            <h3 style={{ textAlign: 'center' }}>Existing Mapping</h3>
            {/* Missing mapping */}
            <s-table>
              <s-table-header-row>
                <s-table-header>Size</s-table-header>
                <s-table-header>Map to</s-table-header>
              </s-table-header-row>
              <s-table-body>
              {existingMapping.map((s) => {
                return <s-table-row key={`existing-${s['original_size']}`}>
                  <s-table-cell>{s['original_size']}</s-table-cell>
                  <s-table-cell>
                    <MapSize
                      label={`Map ${s['original_size']} to`}
                      sizes={sizes}
                      options={mappingOptions}
                      value={[s['converted_size']]}
                      onChange={(value: String) => {
                        setNewMapping({
                          ...newMapping,
                          [s['original_size']]: value
                        })
                      }}
                    />
                  </s-table-cell>
                </s-table-row>
              })}
              </s-table-body>
            </s-table>
          </s-section>
        </s-grid-item>
      </s-grid>
      <s-button disabled={Object.keys(newMapping).length == 0} variant='primary' onClick={handleSave}>Save</s-button>
    </>
  );
};

export default SizeMapping;